import {DocumentsPage as DocumentsPageFeature} from '@features/instructions-and-documents'
import {useParams} from 'react-router'

export const DocumentsPage = () => {
  const {plantId} = useParams<{plantId: string}>()
  if (!plantId) throw new Error('plantId is required')

  // The plant context (UpmPlantProvider) the feature reads is provided app-wide in App.tsx
  return <DocumentsPageFeature plantId={plantId} />
}
